import { SepaScheme, TransactionType } from '@shared/transactions-types';
import type { DeepPartial } from '@luna/utils-ts';
import type { ExportFeatureConfig, TransactionsFeatureConfig } from '@shared/transactions-config';
import { isFeatureEnabled } from '@luna/gatekeeper';

const shouldShowFavoriteField = (): boolean => isFeatureEnabled((f) => f.transactions.favorites);

export const transactions: DeepPartial<TransactionsFeatureConfig> = {
    useFormattedExchangeRate: true,
    showExecutionTimeForTransactionTypes: [TransactionType.INSTANT_PAYMENT],
    showExecutionTimeForSepaSchemes: [SepaScheme.INSTANT_PAYMENT],
    showPartnerAddress: true,
    specialSenderReferenceLabel: true,
    specialReferenceLabelsForForeign: true,
    showExchangeDate: true,
    showSepaRecurrence: true,
    showIbanForInstantPayment: true,
    showPosPaymentSenderAccountFields: true,
    showPosPaymentReceiverAccountFields: true,
    attachmentDownloadByForm: true,
    writtenItems: {
        addBookingType: true,
    },
    retrievals: {
        oidcReady: false,
        preferTokenExchange: false,
        handover: {
            paramNames: ['lang', 'transaction_id', 'transaction_date'],
        },
    },
};

export const exportFeatures: DeepPartial<ExportFeatureConfig> = {
    lastExportOption: true,
    sortParams: [],
    fields: [
        { name: 'ownerAccountTitle', preselected: true, selectable: true },
        { name: 'ownerAccountNumber', preselected: true, selectable: true },
        { name: 'booking', preselected: true, selectable: true },
        { name: 'amount', preselected: true, selectable: false },
        { name: 'currency', preselected: true, selectable: true },
        { name: 'receiver', preselected: true, selectable: true },
        { name: 'reference', preselected: true, selectable: true },
        { name: 'referenceNumber', preselected: false, selectable: true },
        { name: 'note', preselected: false, selectable: true },
        {
            name: 'favorite',
            condition: shouldShowFavoriteField,
            preselected: false,
            selectable: true,
        },
        { name: 'valuation', preselected: false, selectable: true },
        { name: 'category', preselected: false, selectable: true },
        { name: 'cardNumber', preselected: false, selectable: true },
        { name: 'cardLocation', preselected: false, selectable: true },
        { name: 'bookingTypeTranslation', preselected: true, selectable: true },
        { name: 'symbolConstant', preselected: true, selectable: true },
        { name: 'symbolSpecific', preselected: true, selectable: true },
        { name: 'symbolVariable', preselected: true, selectable: true },
        { name: 'senderReference', preselected: false, selectable: true },
        { name: 'senderAddress', preselected: false, selectable: true },
        { name: 'receiverReference', preselected: false, selectable: true },
        { name: 'receiverAddress', preselected: false, selectable: true },
        { name: 'sepaMandateId', preselected: false, selectable: true },
        { name: 'sepaCreditorId', preselected: false, selectable: true },
    ],
};
